import React, { useCallback, useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { Button, TextField, Switch, MenuItem } from "@mui/material";
import {
  icons,
  occurances,
  months,
  appConstants,
} from "../../helpers/constants";
import { escapeHtml } from "../../helpers/common";
import "./EditBudgetDialog.css";
import { Slide, Grid, Box } from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import EditIcon from "@mui/icons-material/Edit";
import CloseIcon from "@mui/icons-material/Close";
import MultipleSelectChip from "../../Components/MultipleSelectChip";
// Package for date picker
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import KeyboardBackspaceRoundedIcon from "@mui/icons-material/KeyboardBackspaceRounded";
import axiosInstance from "../../interceptor/interceptor";
import CircularProgress from "@mui/material/CircularProgress";
import { useSelector } from "react-redux";

import { budgetService } from "../../services/budget.service";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

export default function EditBudgetDialog(props) {
  const { open, closeHandler, budgetId } = props;
  const [step1, setStep1] = React.useState(true);
  const [step2, setStep2] = React.useState(false);
  const [isPremium, setIsPremium] = React.useState(false);
  const [notSure, setNotSure] = React.useState(false);
  // const [lastPaymentDate, setPaymentDate] = React.useState(dayjs());
  const [isLoading, setIsLoading] = useState(false);
  const defaultBudget = useSelector((state) => state.userReducer?.loggedInData?.default_budget);
  const minDate = dayjs().startOf('month').add(1, 'day').set('year', 2000).format('YYYY-MM-DD HH:mm:ss');
  const maxDate = dayjs().startOf('month').add(1, 'day').set('year', 2100).format('YYYY-MM-DD HH:mm:ss');

  const [inputField, setInputField] = React.useState({
    budget_id: budgetId,
    user_id: localStorage.getItem("user_text_obj_data1"),
    name: "",
    amount: "",
    occurance: "",
    months: "",
    date_of_month: "",
    year: "",
    note: "",
    budget_icon: "",
    first_premium_date:dayjs(),
    last_premium_date:dayjs(),
    doc_link:"",
    date_started: ""
  });

  const setIcon = (icon) => {
    setInputField({ ...inputField, budget_icon: icon });
  };

  const inputsHandler = (e) => {
    if(e.target.name == "name" && e.target.value.length > 20){
      setInputField({ ...inputField, [e.target.name]: e.target.value.substring(0,20) });
    }
    if(e.target.name == "amount"){
      if(isNaN(e.target.value)){
        setInputField({ ...inputField, [e.target.name]: e.target.value.substring(0,e.target.value.length-1) });
      }
      else if(e.target.value.length>8){
        setInputField({ ...inputField, [e.target.name]: e.target.value.substring(0,8) });
      }
      else {
        setInputField({ ...inputField, [e.target.name]: e.target.value });
      }
    }
    else if(e.target.name == "note" && e.target.value.length > 65){
      setInputField({ ...inputField, [e.target.name]: e.target.value.substring(0,65) });
    }
    else if(e.target.name == "date_of_month" && e.target.value > 31){
      setInputField({ ...inputField, [e.target.name]: inputField.date_of_month });
    }
    else {
      setInputField({ ...inputField, [e.target.name]: e.target.value });
    }
  };

  const dateInputHandler = (newVal) => {
    setInputField({ ...inputField, first_premium_date: newVal });
  };

  const dateInputHandler2 = (newVal) => {
    setInputField({ ...inputField, last_premium_date: newVal });
  };





  useEffect(() => {
    // API call to get the data from server
    if (budgetId) {
      fetchBudgetData();
    }
  }, [budgetId]);

  function fetchBudgetData() {
    setIsLoading(true);
    budgetService.getBudgetById(localStorage.getItem("user_text_obj_data1"), budgetId).then(
      (res) => {
        setIsLoading(false);
        const newObj = {
          ...inputField,
          budget_id: budgetId,
          budget_type: res.budget_type == 1 ? "income" : "expense",
          name: res.name,
          amount: res.amount,
          occurance: res.occurance ? Number(res.occurance) : "",
          months: res.months || "",
          date_of_month: res.date_of_month || "",
          note: res.note || "",
          budget_icon: res.budget_icon,
          first_premium_date: res.first_premium_date,
          last_premium_date: res.last_premium_date,
          doc_link: res.doc_link,
          date_started: res.date_started
        };
        if(res.last_premium_date){ //res.last_premium_date != 'NULL' || res.last_premium_date != null
          setIsPremium(true);
        }
        
        setInputField(newObj);
        if (
          res.occurance == null &&
          res.months == null &&
          res.date_of_month == null
        ) {
          setNotSure(true);
        }
      },
      (error) => {
        console.error(error, "error!");
      }
    );
  }

  const handleClose = () => {
    closeHandler();
    showBack();
  };

  const inputHandler2 = (inputMonths) => {
    const monthsArr = [];
    months.forEach((item, i) => {
      let index = inputMonths.indexOf(item.name);
      if (index > -1) {
        monthsArr.push(months[i].id);
      }
    });
    setInputField({ ...inputField, months: monthsArr.join() });
  };

  const showNext = () => {
    // Data Validation
    if (inputField.name === "") {
      toast.info("Enter the Name", { type: "error" });
      return false;
    }
    if (isNaN(inputField.amount) || parseInt(inputField.amount) < 0) {
      toast.info("Only positive number in Amount", { type: "error" });
      return false;
    }

    if (notSure == false && inputField.date_of_month === "" && inputField.budget_type ==="expense" && isPremium == false) {
      toast.info("Enter the Date of Payment", { type: "error" });
      return false;
    }

    if (notSure == false &&  parseInt(inputField.date_of_month) > 31 && inputField.budget_type == "expense" && isPremium == false) {
      toast.info("Enter Date of Payment between 1 - 31", { type: "error" });
      return false;
    }    
    if (
      notSure == false &&
      inputField.budget_type == "expense" &&
      inputField.occurance == ""
    ) {
      toast.info("Please select occurance to proceed", { type: "error" });
      return false;
    }

    // Set value of year if occurance is one time
    if (inputField.occurance == 1) {
      if (inputField.months.split(",").length > 1) {
        toast.info("Select single month for One Time Expense", {
          type: "error",
        });
        return false;
      }

      if (parseInt(inputField.months) < new Date().getMonth()) {
        const nxtYr = new Date().getFullYear() + 1;
        setInputField({ ...inputField, year: nxtYr });
      } else {
        setInputField({ ...inputField, year: new Date().getFullYear() });
      }
    }

    setStep1(false);
    setStep2(true);
  };

  const showBack = () => {
    setStep1(true);
    setStep2(false);
  };

  const handleSubmit = async () => {
    if (inputField.budget_icon === "") {
      toast.info("Please select icon to save", { type: "error" });
      return false;
    }
    try {
      let obj = {};
      if (notSure == true) {
        obj = { ...inputField };
        obj.amount = 0;
        obj.occurance = null;
        obj.months = null;
        obj.date_of_month = null;
        obj.year = null;
        obj.note = "";
      } else {
        
        if(isPremium == true){
          const d = new Date(inputField.first_premium_date);
          inputField.first_premium_date = `${d.getFullYear()}-${d.getMonth()+1}-${d.getDate()}`;
          const d2 = new Date(inputField.last_premium_date);
          inputField.last_premium_date = `${d2.getFullYear()}-${d2.getMonth()+1}-${d2.getDate()}`;
          const date = new Date(inputField.first_premium_date);
          inputField.date_of_month = date.getDate();
          inputField.date_started = inputField.first_premium_date;

        } else {
          inputField.first_premium_date = null;
          inputField.last_premium_date = null;
          inputField.doc_link = null;
        }
        obj = { ...inputField };
      }
      obj.default_budget = defaultBudget || 0;
      setIsLoading(true);
      const res = await axiosInstance.post(
        `api?method=create_budget`,
        obj
      );
      setIsLoading(false);
      toast(res.data.message);
      setNotSure(false);
      handleClose();
      // closeHandler();
      // showBack();
    } catch (e) {
      toast.info(`Error: ${e}`, { type: "error" });
    }
  };

  const listicons = icons.map((icon, index) => (
    <Grid item key={index} className="selectIcon">
       <input
          type="radio"
          name="test"
          defaultChecked={icon === inputField.budget_icon}
          id={'icon'+ index}
          onClick={(event) => setIcon(icon)}
        />
      <label key={icon} htmlFor={'icon'+ index}>       
        <Box
          component="img"
          // direction="column"
          // alignItems="center"
          // justifyContent="center"
          className="grid-item"
         
          onClick={(event) => setIcon(icon)}
          alt="Budget icon"
          src={"./images/icons/" + icon}
        />
      </label>
    </Grid>
  ));

  const listMonths = months.map((val, index) => (
    <Grid item key={index} xs={4}></Grid>
  ));

  return (
    <div>
      {/* <ToastContainer /> */}
      {/* <EditIcon variant="outlined" onClick={handleClickOpen} /> */}
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
        className="modalBudgetForm"
      >
        <CloseIcon
          onClick={handleClose}
          sx={{
            position: "absolute",
            cursor: "pointer",
            right: 10,
            top: 10,
            color: (theme) => theme.palette.grey[500],
          }}
        />
        <DialogTitle>Edit Budget</DialogTitle>

        <form className="budget-form">
          {step1 ? (
            <DialogContent>
              <TextField
                value={escapeHtml(inputField.name)}
                onChange={inputsHandler}
                style={{ marginBottom: "10px", width: "100%" }}
                type="text"
                label="Name"
                variant="outlined"
                name="name"
              />

              {inputField.budget_type == "expense" ? (
                <>
                  <br />
                  Not sure about other details ?
                  <Switch
                    onClick={() => setNotSure(!notSure)}
                    checked={notSure}
                  />

                  <br />
                  {notSure == false ? (
                    <>
                      <TextField
                        style={{ marginBottom: "20px", width: "100%" }}
                        name="amount"
                        type="number"
                        label="Amount"
                        variant="outlined"
                        value={inputField.amount}
                        onChange={inputsHandler}
                      />
                      <br />
                      <TextField
                        id="select occurance"
                        style={{ marginBottom: "20px", width: "100%" }}
                        select
                        label="Occurance"
                        name="occurance"
                        key={inputField.occurance}
                        onChange={inputsHandler}
                        defaultValue={inputField.occurance}
                      >
                        {occurances.map((option) => (
                          <MenuItem key={option.value} value={option.value}>
                            {option.label}
                          </MenuItem>
                        ))}
                      </TextField>
                      {listMonths}
                      {!isPremium ? (
                        <>
                          <TextField
                            value={inputField.date_of_month}
                            onChange={inputsHandler}
                            style={{ marginBottom: "20px", width: "100%" }}
                            type="number"
                            label="Date of Payment"
                            variant="outlined"
                            name="date_of_month"
                            InputProps={{ inputProps: { min: 1, max: 31 } }}
                          />
                          <br />
                        </>
                      ) : (
                        <></>
                      )}
                      {inputField.occurance !== 2 ? (
                        <MultipleSelectChip
                          inputHandler2={inputHandler2}
                          selectedMonths={inputField.months}
                        />
                      ) : (
                        <></>
                      )}
                      <TextField
                        value={inputField.note}
                        onChange={inputsHandler}
                        // style={{ marginBottom: "20px", width: "100%" }}
                        type="text"
                        label="Note"
                        variant="outlined"
                        name="note"
                      />
                      <br />
                      <br />
                      <Switch
                        onClick={() => setIsPremium(!isPremium)}
                        defaultChecked={isPremium}
                      />
                      Is a Premium/ Loan EMI ?
                      <br />
                      {isPremium ? (
                        <>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <MobileDatePicker
                            label="First Payment Date"
                            value={inputField.first_premium_date}
                            minDate ={minDate}
                            maxDate = {maxDate}            
                            onChange={(newValue) => {
                              dateInputHandler(newValue);
                            }}
                            renderInput={(params) => <TextField {...params} />}
                          />
                        </LocalizationProvider>
                        <br/><br/>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <MobileDatePicker
                            label="Last Payment Date"
                            value={inputField.last_premium_date}
                            minDate ={minDate}
                            maxDate = {maxDate}            
                            onChange={(newValue) => {
                              dateInputHandler2(newValue);
                            }}
                            renderInput={(params) => <TextField {...params} />}
                          />
                        </LocalizationProvider>
                        <br /><br />
                        <TextField
                        value={inputField.doc_link}
                        onChange={inputsHandler}
                        // style={{ marginBottom: "20px", width: "100%" }}
                        type="text"
                        label="Document link"
                        variant="outlined"
                        name="doc_link"
                      />
                        </>
                      ) : (
                        <></>
                      )}
                    </>
                  ) : (
                    <></>
                  )}
                </>
              ) : (
                <></>
              )}
            </DialogContent>
          ) : (
            <React.Fragment>
              <Box style={{cursor: "pointer", display:"flex", alignItems:"center", padding:"0 20px",marginBottom:"10px"  }}>
                <KeyboardBackspaceRoundedIcon
                  onClick={showBack}
                  style={{cursor: "pointer" }}
                />
                Choose Icon
              </Box>
              <Box className="selectIconBox" sx={{ flexGrow: 1 }}>
                <Grid container>{listicons}</Grid>
              </Box>
              {/* <div className="icon-container">{listicons}</div> */}
            </React.Fragment>
          )}

          <DialogActions>
            {step1 ? (
              <Button onClick={showNext} variant="outlined">Next</Button>
            ) : (
              <Button onClick={handleSubmit} variant="outlined">Save</Button>
            )}
          </DialogActions>
        </form>
      </Dialog>
      {isLoading == false ? (
        <></>
      ) : (
        <div id="overlay">
          <div className="loader">
            <CircularProgress />
          </div>
        </div>
      )}
    </div>
  );
}
